import { useQuery } from "@tanstack/react-query";
import { meetingManager } from "../api/meetings";

export const useFetchMeetingsDetails = ({ meetingId }: { meetingId: string }) => {

    const { data, isLoading, isError, isRefetching, error, refetch } = useQuery({
        queryKey: ["meetings-details", meetingId],
        queryFn: () => meetingManager.getMeetingDetails(meetingId),
        enabled: !!meetingId,
    });

    return {
        meetingDetails: data,
        isLoading: isLoading || isRefetching,
        isError,
        error,
        refetch,
    };

};